import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PublicShell, Loading } from "@/components/shared";
import { NewsletterInline } from "@/components/Newsletter";
import { ShareButtons } from "@/components/ShareButtons";
import NotFound from "@/pages/NotFound";
import api from "@/lib/api";

const PREFIX = { episode: "ep", carousel: "c", guide: "g" };

// Shared loader + page frame for /learn/ep, /learn/c, /learn/g.
export function useLearnItem(type) {
  const { slug } = useParams();
  return useQuery({ queryKey: ["learn-item", type, slug], retry: false,
    queryFn: async () => (await api.get(`/learn/items/${PREFIX[type]}/${slug}`)).data });
}

export function LearnFrame({ query, children }) {
  if (query.isLoading) return <PublicShell><Loading /></PublicShell>;
  if (query.isError || !query.data) return <NotFound />;
  return <PublicShell>{children(query.data)}</PublicShell>;
}

export function LearnFooter({ item, url }) {
  return (
    <>
      <div className="border-t border-border pt-6" data-testid="learn-share-block">
        <p className="mb-3 text-sm font-semibold text-muted">Send this to a business owner who needs it</p>
        <ShareButtons url={url} title={item.title} testid="learn-share" />
      </div>
      <div className="rounded-[10px] border border-border bg-card p-6" data-testid="learn-newsletter">
        <NewsletterInline source="learn" promise="New episodes, carousels and free guides from @bapnadigital, by email."
          doneText="We've sent a one-click confirmation link. Confirm it and you're on the list." finePrint="Free. Unsubscribe in one click." />
      </div>
    </>
  );
}
